export enum AssetType {
  Video = 'video',
  Image = 'image',
  Document = 'doc',
  Audio = 'audio',
}
